import React, { useState } from "react";

import { FormInput_text } from "components";

import { func_validation } from "functions";

import "assets/scss/components/customs/form/customEmailInput.scss";



export function CustomEmailInput(props) {
    const { className, customInputClassName, label, email, isEmailValid, isFormSubmissionAttempted, options } = props;

    // Validate Props
    let isEmailValid_validated = func_validation.isStringTrimNotEmpty(email)? isEmailValid: true;
    let options_validated = func_validation.isObjectNotEmpty(options)? options:{};

    function handleValueChange(value) {
        if (func_validation.isFunction(props.handleValueChange))
            props.handleValueChange(value);
    }

    function handleEmailValidity(isEmailValid) {
        if (func_validation.isFunction(props.handleEmailValidity))
            props.handleEmailValidity(isEmailValid);
    }

    function handleOnEnterPressed() {
        if (func_validation.isFunction(props.handleOnEnterPressed))
            props.handleOnEnterPressed();
    }
    
    return (
        <FormInput_text  
            inputLabel={label}
            className={className}
            customInputClassName={customInputClassName}
            inputName={'email'} inputStateName={'email'} 
            customInputType={'email'} inputValue={email} 
            inputPlaceholder={"Email"}
            propagateValueChange={(stateName, value) => { handleValueChange(value.toLowerCase()); }}
            handleInputChangeExtend={(value) => {
                // Update email validity state in parent
                let isEmailValid = func_validation.testValAgainstRegex(value, func_validation.getRegexEmailCaseInsensitive());
                if (isEmailValid) handleEmailValidity(true);
                else handleEmailValidity(false);
            }}

            handleInputEnterKeyPress={handleOnEnterPressed}
            isInputKeyPressHandlingRequired isFocusRemovedOnEnterKey
            
            inputMaxLength={64} 
            isFormSubmissionAttempted={isFormSubmissionAttempted} 
            customErrorMsgDefault={(isFormSubmissionAttempted && 
                func_validation.isStringTrimEmpty(email))? 
                "Email is required": "Invalid Email"} 
            customErrorValidation={(!isEmailValid_validated) || 
                (isFormSubmissionAttempted && func_validation.isStringTrimEmpty(email))}

            inputCustomOptions={{ autoComplete: "off" }}

            isInputValueTrim_onChange
            isLabelOptional isInputOptional

            {...options_validated}
        />
    )
}